import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Router } from "@angular/router";
import {Status} from './status';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";


@Injectable({
  providedIn: 'root'
})
export class LoginService {
signinerrormessage: any;
redirecturl: any;
user:any=false;
admin:any=false;
toUseIdToken: any;

vendor:boolean = false;
collector:boolean = false;
customer: boolean = false;
  constructor(private http: HttpClient, private router: Router) {
    firebase.auth().onAuthStateChanged((user)=>{
      console.log(user);
      if(user){
        this.user = user;

        if(!this.redirecturl){this.redirecturl = "/admin"}
            this.router.navigate([`${this.redirecturl}`]);

    console.log(this.user);


  }  else{
      this.user=false;
      this.router.navigate(['/login']);
    }

  });
  }




  login(hi):void{
    console.log("in login service");
    firebase.auth().signInWithEmailAndPassword(hi.email, hi.password).then(()=>{

if(this.user ){
  this.user.getIdToken(/* forceRefresh */ true).then((idToken)=>{
  // Send token to your backend via HTTPS
  // ...
  console.log(idToken);
  this.toUseIdToken = idToken;


  console.log(this.user);
  if(!this.redirecturl){this.redirecturl = "/admin"}
      
this.router.navigate([`${this.redirecturl}`]);


  }).catch(function(error) {
  // Handle error
  console.log(error);

  });

}
}

    ).catch((error)=>{
      switch(error.code){
        case "auth/invalid-email":
        this.signinerrormessage = "the email entered is not valid";
        break;
        case "auth/user-not-found":
        this.signinerrormessage ="there is no user corresponding to the given email.";
        break;
        case "auth/wrong-password":
        this.signinerrormessage ="The password is invalid for the given email";
        break;
        default:
        this.signinerrormessage = "An error ocurred";
        break;
      }
      alert(this.signinerrormessage);
      return(this.signinerrormessage);
    });

  }

 signout():void{
(async function(){
  await firebase.auth().signOut();
  this.router.navigate(['/login']);
})();
}


}
